import { createSlice } from "@reduxjs/toolkit";
const initialState =
{
    loadingFlagSummary:0,
    jobDetails: {},
    errorMessage: '',
    jobId: undefined,
    backPath: '/joblist',
    dataLoaded: false,
    editMode: false,
    modifyTimeInfo:{
        checkintime:"",
        checkouttime:"",
        shiftstarttime:"",
        shiftendtime:""
    },
    viewVariableRate:{
        viewPayRate:[],
        viewMileage:[]
    }
}

export const jobDetailsSlice = createSlice({
    name: 'jobDetails',
    initialState,
    reducers: {
        updateJobDetails: (state, action) => {
            state.jobDetails = action.payload.data;
            if(action.payload.backPath) {
                state.backPath = action.payload.backPath;
            }
            state.editMode = action.payload.editMode || state.editMode;
            state.dataLoaded = true;
            state.jobId = action.payload.jobId;
        },
        updateJobFailed: (state, action) => {
            state.errorMessage = action.payload;
        },
        setJobId: (state, action) => {
            state.jobId = action.payload.jobId;
            state.dataLoaded = false;
            state.backPath = action.payload.backPath;
            state.editMode = action.payload.editMode;
        },
        setLoadingFlagIncrement:state => {
            state.loadingFlagSummary = state.loadingFlagSummary + 1
        },
        setLoadingFlagDecrement: state => {
            if (state.loadingFlagSummary !== 0) {
                state.loadingFlagSummary = state.loadingFlagSummary - 1
            }
        },
        setModifyTimeInfo:(state,{payload:{name,value}}) => {
            state.modifyTimeInfo[name] = value;
        },
        setViewVariableRate:(state,{payload}) => {
            state.viewVariableRate[payload?.name] = payload.value;
        }
    }
});

export const {
    updateJobDetails,
    updateJobFailed,
    setJobId,
    setLoadingFlagIncrement,
    setLoadingFlagDecrement,
    setModifyTimeInfo,
    setViewVariableRate
} = jobDetailsSlice.actions;

export default jobDetailsSlice.reducer;
